import React from 'react'
import './logoutBtn.scss'
import { useSelector } from 'react-redux'
import { useLogout } from '../../modules/requests/logOut'
import LogoutIcon from '../../generic/icons/IconLib/LogoutIcon'
import styled from 'styled-components'

export const IconWrapperControl = styled.div`
    height: 2.5em;
    width: 2.5em;
    border-radius: 50%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #297f76;
    cursor: pointer;

    svg {
        width: 1em; height: 1em;
    }
`
function LogOutBtn() {
    const getToken = useSelector(token => token.mainReducer.token);
    const logout = useLogout();

    return (
        <IconWrapperControl onClick={() => logout(getToken)}>
            <LogoutIcon />
        </IconWrapperControl>
    )
}
export default LogOutBtn;
